import React from 'react';

function Footer() {
  return (
    <div className='container'>
      <div className='row justify-content-center mt-2'>
        Copyright &copy; 2020. Powered by Comza & e-Step | Terms & Privacy
      </div>
    </div>
  );
}

export default Footer;
